import { format } from 'date-fns';
import ru from 'date-fns/locale/ru';
import { PartnerFinancesTableDictionary } from 'types/i18n';
import { sharedDictionaryRu } from './sharedDictionaryRu';

export const partnerFinancesTableDictionaryRu: PartnerFinancesTableDictionary = {
  balanceAmountLabel: 'Баланс',
  earnedAmountLabel: 'Заработано всего',
  paidAmountLabel: 'Выплачено всего',
  rewardLabelText: 'Выплата вознаграждения',
  periodMonthText(dateISO) {
    return sharedDictionaryRu.dates.monthOfYearDate(new Date(dateISO));
  },
  periodEarnedLabel: 'Заработано',
  periodPaidLabel: 'Выплачено',
  transferMonthText(date) {
    return format(new Date(date), 'd MMMM yyy', { locale: ru });
  },
  transferPeriodText(startDate, endDate) {
    const startDayOfMonth = format(new Date(startDate), 'd', { locale: ru });

    const endDayOfMonth = format(new Date(endDate), 'd', { locale: ru });

    const monthName = format(new Date(startDate), 'MMMM', { locale: ru });

    return `За период с ${startDayOfMonth} по ${endDayOfMonth} ${monthName}`;
  },
  transferIncomeText(amount) {
    return `+ ${sharedDictionaryRu.moneyAmountText(amount, 'USD')}`;
  },
  createRewardActionText: 'Добавить выплату',
  editRewardActionText: 'Изменить',
};
